import { createFileRoute } from '@tanstack/react-router';

import { SignedOutPage } from '../pages/SignedOutPage';

export const Route = createFileRoute('/signed-out')({
  component: SignedOutPage,
});
